import ProductWillBeAddedSoon from "../ProductWillBeAddedSoon";

const GamePage = () => {
  return <ProductWillBeAddedSoon />;
};

export default GamePage;
